function equalizePreambleHeights() {
    const pricingBoxes = document.querySelectorAll('.pricing-boxes-updated');

    pricingBoxes.forEach(section => {
        const preambles = section.querySelectorAll('.preamble');

        if (preambles.length <= 1) return; //don't fix if only one

        // Reset
        preambles.forEach(preamble => {
            preamble.style.height = 'auto';
        });


        //check break
        const isLargeScreen = window.matchMedia('(min-width: 768px)').matches;

        if (isLargeScreen) {
            // tallest preamble
            let maxHeight = 0;
            preambles.forEach(preamble => {
                const height = preamble.offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            // all preambles to maxi height
            preambles.forEach(preamble => {
                preamble.style.height = maxHeight + 'px';
            });
        }
    });
}

// Run on page load
document.addEventListener('DOMContentLoaded', equalizePreambleHeights);

// Run on window resize with debouncing
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(equalizePreambleHeights, 250);
});
